<template>
  <div>
    <Header />
    <section class="section1">
      <div class="container container-space-y-l">
        <div class="h1">优卖CRM，为您提供优质的服务</div>
        <div class="desc">
          催付提醒 / 发货提醒 / 自动催评 / 中差评安抚 / 会员管理 / 精准营销 / 数据分析
        </div>
      </div>
    </section>

    <section class="section2">
      <div class="container container-space-y-m">
        <div class="section2-title">功能亮点</div>
        <ul class="section2-functions">
          <li>
            <div class="section2-fun-title">订单关怀</div>
            <div class="section2-fun-desc">自动化关怀，全流程跟踪</div>
          </li>
          <li>
            <div class="section2-fun-title">会员管理</div>
            <div class="section2-fun-desc">个性化标签、高级分组、客户列表</div>
          </li>
          <li>
            <div class="section2-fun-title">精准营销</div>
            <div class="section2-fun-desc">多种营销方式智能组合</div>
          </li>
          <li>
            <div class="section2-fun-title">数据分析</div>
            <div class="section2-fun-desc">会员、订单、商品多维度分析</div>
          </li>
          <li>
            <div class="section2-fun-title">商品管理</div>
            <div class="section2-fun-desc">自动上下架，商品属性调整</div>
          </li>
        </ul>
      </div>
    </section>

    <section class="section3 container-space-y-s">
      <device-browser shadow="none">
        <!-- <div class="bg-img-auto img-1"></div> -->
        <!-- <div class="bg-img-auto img-2"></div> -->
        <div class="bg-img-auto img-3"></div>
        <div class="bg-img-auto img-4"></div>
        <div class="bg-img-auto img-5"></div>
        <div class="bg-img-auto img-6"></div>
        <div class="bg-img-auto img-7"></div>
        <div class="bg-img-auto img-8"></div>
        <div class="bg-img-auto img-9"></div>
        <div class="bg-img-auto img-10"></div>
        <div class="bg-img-auto img-11"></div>
        <div class="bg-img-auto img-12"></div>
        <div class="bg-img-auto img-13"></div>
        <div class="bg-img-auto img-14"></div>
        <div class="bg-img-auto img-15"></div>
      </device-browser>
    </section>

    <BannerRegistration />
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/header'
import Footer from '@/components/footer'
import DeviceBrowser from '@/components/device-browser'
import BannerRegistration from '@/components/banner-registration'
export default {
  name: 'CRM',
  components: {
    Header,
    Footer,
    DeviceBrowser,
    BannerRegistration
  }
}

</script>

<style lang="scss" scoped>
.section1 {
  width: 100%;
  height: 60vh;
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.7)),
    url("~@/assets/images/bg3.jpg");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: 100vw;
  backdrop-filter: blur(50px);
  background-repeat: no-repeat;
  background-position: center;
  color: #fff;

  .desc {
    color: #c5c5c5;
  }
}

.section2 {
  .section2-title {
    font-size: 20px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 30px;
  }

  .section2-functions {
    display: flex;

    li {
      flex-basis: 0;
      flex-grow: 1;
      max-width: 100%;
      text-align: center;

      .section2-fun-title {
        font-size: 18px;
        margin-bottom: 8px;
      }
      .section2-fun-desc {
        font-size: 12px;
      }
    }
  }
}

.section3 {
  background: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)),
    url("~@/assets/images/bg3.jpg");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: 100vw;
  backdrop-filter: blur(50px);
}

.img-1 {
  background-image: url(~@/assets/images/crm/1.jpg);
}
.img-1::after {
  padding: 28.1%;
}
.img-2 {
  background-image: url(~@/assets/images/crm/2.jpg);
}
.img-2::after {
  padding: 92.4%;
}
.img-3 {
  background-image: url(~@/assets/images/crm/3.jpg);
}
.img-3::after {
  padding: 49.2%;
}
.img-4 {
  background-image: url(~@/assets/images/crm/4.jpg);
}
.img-4::after {
  padding: 77.4%;
}
.img-5 {
  background-image: url(~@/assets/images/crm/5.jpg);
}
.img-5::after {
  padding: 129.1%;
}
.img-6 {
  background-image: url(~@/assets/images/crm/6.jpg);
}
.img-6::after {
  padding: 111.9%;
}
.img-7 {
  background-image: url(~@/assets/images/crm/7.jpg);
}
.img-7::after {
  padding: 109.3%;
}
.img-8 {
  background-image: url(~@/assets/images/crm/8.jpg);
}
.img-8::after {
  padding: 44.5%;
}
.img-9 {
  background-image: url(~@/assets/images/crm/9.jpg);
}
.img-9::after {
  padding: 100.7%;
}
.img-10 {
  background-image: url(~@/assets/images/crm/10.jpg);
}
.img-10::after {
  padding: 81%;
}
.img-11 {
  background-image: url(~@/assets/images/crm/11.jpg);
}
.img-11::after {
  padding: 77.2%;
}
.img-12 {
  background-image: url(~@/assets/images/crm/12.jpg);
}
.img-12::after {
  padding: 107%;
}
.img-13 {
  background-image: url(~@/assets/images/crm/13.jpg);
}
.img-13::after {
  padding: 109%;
}
.img-14 {
  background-image: url(~@/assets/images/crm/14.jpg);
}
.img-14::after {
  padding: 71%;
}
.img-15 {
  background-image: url(~@/assets/images/crm/15.jpg);
}
.img-15::after {
  padding: 105%;
}
</style>
